import { useState, useEffect, useContext } from 'react';
import { publicAxiosInstance, privateAxiosInstance } from '../api/axios';
import { AuthContext } from '../contexts/AuthContext';
import handleErrors from '../utils/errorHandler';

export default function useAdvisor(advisorId) {
  const { authState } = useContext(AuthContext);
  const [advisor, setAdvisor] = useState(null);
  const [hasUserReview, setHasUserReview] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAdvisor = async () => {
      setIsLoading(true);
      try {
        const advisorResp = await publicAxiosInstance.get(`/api/v1/advisors/${advisorId}/`);
        setAdvisor(advisorResp.data);
        if (authState.isAuthorized) {
          const userReviewResp = await privateAxiosInstance.get(
            `/api/v1/reviews/user-reviews/?advisor_id=${advisorId}`
          );
          setHasUserReview(userReviewResp.data.length > 0);
        } else {
          setHasUserReview(false);
        }
      } catch (error) {
        console.error('Error fetching advisor data:', handleErrors(error));
      } finally {
        setIsLoading(false);
      }
    };
    fetchAdvisor();
  }, [advisorId, authState.isAuthorized]);

  return { advisor, setAdvisor, hasUserReview, setHasUserReview, isLoading };
}
